module.exports = __webpack_public_path__ + "641acc31.svg";